import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-mobile-overlay',
    templateUrl: './mobile-overlay.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MobileOverlayComponent {
}
